// App-wide constants. Values that don't vary per environment.
const config = {
    version: '0.9.2',
    oktaPasswordRecoveryURL: 'https://dev-9116264.okta.com/api/v1/authn/recovery/password',
    oktaUserCookieName: "ts-dash-user",
    rememberUserLoginCookieName: "ts-dash-login",
    loggedInHomeEndpoint: "/",
};

const googleMapScriptLibraries = ['places'];

const auth0AuthorizationParams = {
    audience: "https://actionfigure.us.auth0.com/api/v2/",
    scope: "openid profile email offline_access",
};

// Per-environment runtime config. Replaces the build-time REACT_APP_* env-var
// pattern that Heroku used (where vars were baked in by webpack at npm run
// build).
//
// We now build once and ship the same artifact to every env. The artifact
// reads window.location.hostname at boot to pick which env it's in.
//
// Anything in this object is shipped to every browser. Don't put genuine
// secrets here — the API keys present are semi-public service keys (Mapbox,
// Google Maps, etc.) constrained server-side at the provider.

const envCommon = {
    ACTIONFIGURE_CUSTOMER_ID:    'b74dd933-9ddf-468c-b32b-3783c1062af5',
    PGA_CUSTOMER_ID:             '8395e5de-818a-4144-ac9c-615f216a90ad',
    API_GATEWAY_TOKEN_URL:       'https://api.actionfigure.ai/auth/v1/token',
    AUTH0_CLIENT_ID:             '3eks4z9q59vPB5c9Q8KKyU9OMcMYcg7l',
    AUTH0_DOMAIN:                'https://actionfigure.us.auth0.com',
    AUTH0_MANAGEMENT_API_URL:    'https://actionfigure.us.auth0.com/api/v2',
    AWS_CUSTOMER_LOGO_URL:       'https://actionfigure-public-customer-assets.s3.amazonaws.com',
    AWS_URL:                     'https://actionfigure-messaging.s3.amazonaws.com',
    BIZ_API_KEY:                 '6aFYb2OnPtHz4MP9ihGZRJjkgOUsjuhO',
    DATADROP_URL:                'https://api.actionfigure.ai/data-drop/v1',
    GMAPS_KEY:                   'AIzaSyDFo9NSxCFAqeY-4J0ZIDUvYSJ0pa3Hl48',
    JOURNEY_API_KEY:             '9EDYtskTvX2VMam9u4ojvlXrL4bFEY6JCC80zzwbeyWYhpfSHcKXcIFHy8SlUjLg',
    JOURNEY_BATCH_URL:           'https://journey-batch.actionfigure.ai/v1',
    MAPBOX_API_KEY:              'pk.eyJ1IjoidHJhbnNpdHNjcmVlbmFkbWluIiwiYSI6ImNqMmdwbmNiaDAwMnkzOWxncGYwbXRiOWUifQ.3wkLfeQMLoVI12Zr_pN7Qg',
    MAPBOX_GEOCODING_API_URL:    'https://api.mapbox.com/geocoding/v5/mapbox.places',
    MESSAGE_LOADER_URL:          'https://go.actionfigure.ai/static/loader/message.html',
    MOB_API_KEY:                 'Ctp8JLmxP82e6hj2',
    OKTA_CLIENT_ID:              '0oapnyd78s75d939x357',
    OKTA_CLIENT_SECRET:          '89fSh4y8vc4gsxDjyZQJceMNPm3Nzqjhbvf4hRkr',
    S3_MESSAGING_BUCKET:         'actionfigure-messaging.s3.amazonaws.com/',
    SCOREFINDER_API_KEY:         'c2346bD36c6be77ec518a3dde1e1c8E480f5A36d6f',
    TIMEZONE_API_KEY:            'I95fOusLqrvVRxa8MY9s',
};

const envByEnv = {
    prod: {
        BIZ_BASE_URL:       'https://biz.actionfigure.ai',
        CITYMO_URL:         'https://citymotion.io',
        LOADER_URL:         'https://go.actionfigure.ai',
        MAPPER_LINK:        'https://mapper.actionfigure.ai',
        MOB_URL:            'https://mobilityscore.transitscreen.io',
        SEND_TO_DATADROP:   'true',
        TRANSITSCREEN_URL:  'https://transitscreen.io/',
    },
    staging: {
        BIZ_BASE_URL:       'https://biz-staging.actionfigure.ai',
        CITYMO_URL:         'https://staging.citymotion.io',
        LOADER_URL:         'https://staging.go.actionfigure.ai',
        MAPPER_LINK:        'https://mapper-staging.actionfigure.ai',
        MOB_URL:            'https://mobilityscore-staging.transitscreen.io',
        SEND_TO_DATADROP:   'false',
        TRANSITSCREEN_URL:  'https://staging.transitscreen.io/',
    },
    // Local cluster (k3d). Talks to local cluster services where they exist;
    // falls back to staging-external for services not yet hosted locally.
    local: {
        BIZ_BASE_URL:       'https://biz.actionfigure.test',
        CITYMO_URL:         'https://staging.citymotion.io',
        LOADER_URL:         'https://go.actionfigure.test',
        MAPPER_LINK:        'https://mapper-staging.actionfigure.ai',
        MOB_URL:            'https://mobilityscore-staging.transitscreen.io',
        SEND_TO_DATADROP:   'false',
        TRANSITSCREEN_URL:  'https://staging.transitscreen.io/',
    },
};

const pickEnv = () => {
    const h = (typeof window !== 'undefined' && window.location && window.location.hostname) || '';
    if (h === 'home.actionfigure.ai')         return 'prod';
    if (h === 'home-staging.actionfigure.ai') return 'staging';
    // Anything else: home.actionfigure.test (k3d), home.actionfigure.local
    // (CRA dev server), localhost, etc.
    return 'local';
};

const env = { ...envCommon, ...envByEnv[pickEnv()] };

export {
    config,
    googleMapScriptLibraries,
    auth0AuthorizationParams,
    env,
};
